<template>
  <v-container class="fill-height bg_btn_soft_gradient" fluid>
    <v-row justify="center" align="center">
      <v-col cols="12">
        <router-view class="animate-fadeIn" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {};
</script>
